const ORIGINAL_DISABLED_ATTR = 'data-wtoy-orig-disabled';

function ensureSpinner(el) {
    if (el.querySelector(':scope > .wtoy-spinner')) {
        return;
    }
    const spinner = document.createElement('span');
    spinner.className = 'wtoy-spinner';
    el.appendChild(spinner);
}

function removeSpinner(el) {
    const spinner = el.querySelector(':scope > .wtoy-spinner');
    if (spinner) {
        spinner.remove();
    }
}

export function setButtonBusy(el, busy) {
    if (!el) {
        return;
    }

    if (busy) {
        if (el.classList.contains('is-busy')) {
            return;
        }
        el.setAttribute(ORIGINAL_DISABLED_ATTR, el.disabled ? '1' : '0');
        el.classList.add('is-busy');
        el.disabled = true;
        el.setAttribute('aria-busy', 'true');
        ensureSpinner(el);
        return;
    }

    if (!el.classList.contains('is-busy')) {
        return;
    }
    const hadDisabled = el.getAttribute(ORIGINAL_DISABLED_ATTR) === '1';
    el.removeAttribute(ORIGINAL_DISABLED_ATTR);
    el.classList.remove('is-busy');
    el.disabled = hadDisabled;
    el.removeAttribute('aria-busy');
    removeSpinner(el);
}

export function setFieldSkeleton(el, busy) {
    if (!el) {
        return;
    }

    if (busy) {
        if (el.classList.contains('wtoy-skeleton')) {
            return;
        }
        el.classList.add('wtoy-skeleton');
        el.setAttribute('aria-busy', 'true');
        return;
    }

    if (!el.classList.contains('wtoy-skeleton')) {
        return;
    }
    el.classList.remove('wtoy-skeleton');
    el.removeAttribute('aria-busy');
}

export function setModalBusy(el, busy) {
    if (!el) {
        return;
    }
    // 遮罩罩住卡片本體（.wtoy-modal-content），不是 .wtoy-modal 那層全視窗 fixed 層
    const veilHost = el.querySelector(':scope > .wtoy-modal-content') || el;

    if (busy) {
        if (el.getAttribute('data-busy') === '1') {
            return;
        }
        el.setAttribute('data-busy', '1');
        el.setAttribute('aria-busy', 'true');
        if (!veilHost.querySelector(':scope > .wtoy-modal-busy-veil')) {
            const veil = document.createElement('div');
            veil.className = 'wtoy-modal-busy-veil';
            veil.appendChild(createVeilSpinner());
            veilHost.appendChild(veil);
        }
        return;
    }

    if (el.getAttribute('data-busy') !== '1') {
        return;
    }
    el.removeAttribute('data-busy');
    el.removeAttribute('aria-busy');
    const veil = veilHost.querySelector(':scope > .wtoy-modal-busy-veil');
    if (veil) {
        veil.remove();
    }
}

function createVeilSpinner() {
    const spinner = document.createElement('span');
    spinner.className = 'wtoy-spinner';
    return spinner;
}

export function setLocked(els, locked) {
    if (!els) {
        return;
    }
    const list = els.length !== undefined ? els : [els];
    for (const el of list) {
        if (!el) {
            continue;
        }
        if (locked) {
            el.classList.add('is-locked');
        } else {
            el.classList.remove('is-locked');
        }
    }
}
